import React from "react";
import { NavLink } from "react-router-dom";

/**
 * Renders staff image, name, and designation
 * @param {{}} item staff object
 */
const StaffProfileCard = ({ item = null }) => {
	if (item) {
		const { surname, first_name, middle_name } = item;
		const name = `${surname} ${first_name} ${
			middle_name ? middle_name : ""
		}`;
		return (
			<NavLink
				className="profile-item-link"
				to={{
					pathname: "/home/staffing/profile",
					search: `?ref=${item.id}`,
					state: { activeStaff: item }
				}}
			>
				<div className="flex">
					<div className="flex-item p-t-5">
						<strong className="text-primary">{name}</strong>
						<br />
						<span>
							<strong>{item.designation.name} </strong>
						</span>
					</div>
				</div>
			</NavLink>
		);
	}
	return null;
};

export default StaffProfileCard;
